import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AccessibilityInfo, View } from 'react-native';

import { SPINE_ASSETS } from '../../../assets/spine';
import SpineAnimation from '../../../components/SpineAnimation';

const SPINE_LANGUAGES = new Set(['en', 'bg', 'fr', 'ru', 'tr']);

export const PLAY_NOW_BOUNDS = { width: 304, height: 135 } as const;

const useReduceMotion = () => {
	const [reduceMotion, setReduceMotion] = useState(false);

	useEffect(() => {
		AccessibilityInfo.isReduceMotionEnabled().then(setReduceMotion);
		const subscription = AccessibilityInfo.addEventListener('reduceMotionChanged', setReduceMotion);
		return () => subscription.remove();
	}, []);

	return reduceMotion;
};

const PlayNowAnimation = ({ width, height }: { width: number; height: number }) => {
	const { i18n } = useTranslation();
	const reduceMotion = useReduceMotion();
	const language = i18n.language.split('-')[0].toLowerCase();
	const skin = SPINE_LANGUAGES.has(language) ? language : 'en';

	return (
		<View pointerEvents='none' style={{ width, height }}>
			<SpineAnimation
				skeletonFile={SPINE_ASSETS.playNowHome.skeletonFile}
				atlasFile={SPINE_ASSETS.playNowHome.atlasFile}
				animationName={SPINE_ASSETS.playNowHome.animations.idle}
				skin={skin}
				loop
				playing={!reduceMotion}
				width={width}
				height={height}
			/>
		</View>
	);
};

export default PlayNowAnimation;
